import React, { StrictMode, useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { domAnimation, LazyMotion } from 'framer-motion';
import { queryClient } from '../http/query-client';
import { SiteConfigContext } from './settings/site-config-context';
import { SiteConfig } from '@app/site-config';
import deepMerge from 'deepmerge';
import { BaseSiteConfig } from './settings/base-site-config';
// import {ThemeProvider} from './theme-provider';
import { BootstrapDataProvider } from './bootstrap-data/bootstrap-data-provider';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// import devtoolsDetect from 'devtools-detect';
interface ProvidersProps {
  children: any;
}

const mergedConfig = deepMerge(BaseSiteConfig, SiteConfig);

// const t = function anonymous() {
//   debugger;
// };

export function CommonProvider({ children }: ProvidersProps) {
  // run debugger if console in open
  // console.log('first', devtoolsDetect);
  // useEffect(() => {
  //   if (devtoolsDetect?.isOpen) {
  //     t();
  //   }

  //   return () => {
  //     console.log('cleanup');
  //   };
  // }, [devtoolsDetect]);

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <LazyMotion features={domAnimation}>
          <SiteConfigContext.Provider value={mergedConfig}>
            <BootstrapDataProvider>
              {/* <ThemeProvider> */}
              {children}
              {/* </ThemeProvider> */}
            </BootstrapDataProvider>
          </SiteConfigContext.Provider>
        </LazyMotion>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </StrictMode>
  );
}
